import React, { useEffect, useState, useRef, use } from 'react'
import { getFolders, DeleteAgentByID, _get } from './../../utils/APIClient'
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { triggerAlert, ConfirmationAlert } from './../../utils/commonFunctions'
import moment from 'moment';
import Modal from 'react-bootstrap/Modal';
import smallsample from './../../assets/calling-prof.webp'
import { set, useForm, } from "react-hook-form";
import { getOnlyToken } from '../../utils/commonFunctions';
import { onlyAlphabetsandSpaces } from '../../utils/Constants';
import axios from "axios";
import { FiChevronDown } from "react-icons/fi";
import { useContext } from "react";
import Loader from '../../Components/Loader';
import DataTable from 'react-data-table-component';


// import { PromptContext } from "../promptContext";

export default function AiAgent() {
    document.title = "Callingo | AI Agents"
    const [ListofAiAgents, setListofAiAgents] = useState([])
    const [ListofFolders, setListofFolders] = useState([]);
    const [hide, sethide] = useState(false)
    const [selectedFolder, setSelectedFolder] = useState(null);
    const [selectedFolderId, setSelectedFolderId] = useState(null);
    const [loading, setLoading] = useState(false);
    const [personaLoading,setPerLoading] = useState(false)
    const [agentID, setagentID] = useState();
    const [searchTerm, setSearchTerm] = useState("");
    const [agentLoading, setAgentLoading] = useState(false)
    const [currentPage, setCurrentPage] = useState(1);
    const [perPage, setPerPage] = useState(10);
    const [totalCount, setTotalCount] = useState(0);
    const navigate = useNavigate();
    const [selectedId, setSelectedId] = useState(null);
    
 

     useEffect(() => {
        fetchAgentsForFolder();
    }, [])
    const menuRef = useRef()


const [showSuccessModal, setShowSuccessModal] = useState(false);
const [showErrorModal, setShowErrorModal] = useState(false);
const [successMessage, setSuccessMessage] = useState('');
const [errorMessage, setErrorMessage] = useState('');



    const fetchAgentsForFolder = async (pageNum = 1, pageSize = 10) => {
        setAgentLoading(true);
        try {
            const response = await _get(`api/agents/agent-dropdown/?pagenumber=${pageNum}&perpage=${pageSize}`);
            if (response.status === 200) {
                // assume agents returned in response.data.agents or response.data.data
                const agents = response.data.data || [];
                const pagination = response.data.pagination || {};
                setListofAiAgents(agents);
                setCurrentPage(pagination.current_page || pageNum);
                setPerPage(pagination.per_page || pageSize);
                setTotalCount(pagination.total_count || 0);
            } else {
                setListofAiAgents([]);
            }
        } catch (error) {
            console.error('Failed to fetch agents for folder', error);
            setListofAiAgents([]);
        } finally {
            setAgentLoading(false);
        }
    };

    const handlePageChange = (page) => {
        fetchAgentsForFolder(page, perPage);
    };

    const handlePerPageChange = (newPerPage) => {
        setPerPage(newPerPage);
        fetchAgentsForFolder(1, newPerPage);
    };

    const DeleteAgent = async (data) => {
        try {
            const response = await DeleteAgentByID(data.agent_id);
            const respdata = response.data;
            if (respdata.status_code == 200) {
                triggerAlert('success', '', `Agent deleted successfully` || 'Something went wrong');
                // refresh agents for current folder
                fetchAgentsForFolder(currentPage, perPage);
            }
        } catch (error) {
            triggerAlert('error', '', error.response.data.message || 'Something went wrong');
            console.error(error);
        }
    }
  

    const columns = [
        {
            name: "S.NO",
            width: "90px",
             selector: (row, index) => index + 1,
            sortable: true,
        },
        {
            name: "Agent",
            sortable: true,
            cell: (row) => (
                <div className="d-flex align-items-center gap-2" style={{ maxWidth: "250px" }}>
                    {/* <img
                        src={row.agent_profile_picture || smallsample}
                        alt={row.agent_name}
                        style={{
                            width: "40px",
                            height: "40px",
                            border: "1px solid #979c94ff",
                            borderRadius: "50%",
                            objectFit: "cover",
                            flexShrink: 0,
                        }}
                    /> */}

                    <span
                        className="text-success fw-bold"
                        title={row.agent_name}   
                        style={{
                            maxWidth: "250px",    
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            display: "block",
                        }}
                    >
                        {row.agent_name}
                    </span>
                </div>
            ),
        },
        {
            name: 'Position',
            selector: row => row.agent_position,
            sortable: true,
        },
        {
            name: "Agent Type",
            center: true,
            sortable: true,
         cell: (row) => (
  <span
    className={`badge fw-semibold px-2 py-1 ${
      row.agent_type === "out-bound"
        ? "bg-primary text-white"
        : "bg-success text-white"
    }`}
  >
    {row.agent_type}
  </span>
),

        },
        {
            name: 'Created',
            selector: row => row.created_at,
            sortable: true,
            cell: row => moment(row.created_at).fromNow(),
        },
        {
            name: 'Status',
            width:'200px',
            center:true,
            cell: row => (
                <span className={`badge ${row.is_active ? 'bg-success' : 'bg-secondary'}`}>
                    {row.is_active ? 'Active' : 'Inactive'}
                </span>
            ),
        },
        {
            name: 'Actions',
            cell: row => (
                <div className="d-flex gap-1">
                    <span
                        className="action-btn call-btn"
                        onClick={() => navigate('/usercalllogs')}
                        title="Call"
                    >
                        <i className="ri-phone-fill"></i>
                    </span>
                    <Link
                        className="action-btn edit-btn"
                        to={`/agentcreation?agentid=${row.agent_id}&isupdate=true`}
                        title="Edit"
                    >
                        <i className="ri-edit-box-line"></i>
                    </Link>
                    <span
                        className="action-btn delete-btn"
                        onClick={() => {
                            ConfirmationAlert(
                                "Do you want to delete agent from database",
                                "Delete",
                                () => DeleteAgent(row)
                            );
                        }}
                        title="Delete"
                    >
                        <i className="ri-delete-bin-line"></i>
                    </span>
                </div>
            ),
        },
    ]

    const customStyles = {
        table: {
            style: {
                backgroundColor: "#1A1C2B",
                color: "#FFFFFF",
            },
        },
        headRow: {
            style: {
                backgroundColor: "#2b3544ff",
                borderBottom: "1px solid rgb(70,79,91)",
                minHeight: "45px",
            },
        },
        headCells: {
            style: {
                color: "#fff",
                fontSize: "14px",
                fontWeight: 600,
                borderRight: "1px solid rgb(70,79,91)",
            },
        },
        rows: {
            style: {
                backgroundColor: "#1A1C2B",
                color: "#fff",
                minHeight: "48px",
                "&:hover": {
                    backgroundColor: "#23263A",
                },
            },
        },
        cells: {
            style: {
                borderBottom: "1px solid rgb(70,79,91)",
                fontSize: "14px",
                color: "#E1E1E1",
            },
        },
        pagination: {
            style: {
                backgroundColor: "#1A1C2B",
                color: "#FFFFFF",
                borderTop: "1px solid rgb(70,79,91)",
            },
            pageButtonsStyle: {
                color: "#FFFFFF !important",
                fill: "#FFFFFF !important",
                "&:hover": {
                    backgroundColor: "#2A2D3F",
                },
                "&:disabled": {
                    color: "#777 !important",
                    fill: "#777 !important",
                },
            },
        },

        noData: {
            style: {
                backgroundColor: "transparent",
                color: "#fff",
                padding: "20px",
            },
        },
    };

    return (
        <>
            <div className="container-fluid">
                <div className="row">
                    <div className="col-12">
                        <div className="page-title-box">
                            <div className="page-title-right">
                               <div className='d-flex gap-2'>
                                 {/* <div className="d-flex align-items-center  gap-3">
                                    <Link
                                        to="/folders"
                                        className="btn btn-success fw-semibold"
                                    >
                                        <i className="ri-folder-add-line me-1"></i>
                                        New Company
                                    </Link>
                                </div> */}

                                <div className="d-flex align-items-center gap-2">
                                    <div ref={menuRef} className="position-relative">
                                        <button
                                            className="btn btn-primary d-flex align-items-center gap-1"
                                            onClick={() =>
                                                //      setShow(!show)
                                                 navigate('/agentcreation')
                                                }
                                        >
                                            Create Agent
                                            {/* <FiChevronDown size={18} /> */}
                                        </button>

                                        {/* {show && (
                                            <div className="jc-dropdown-box" id="CreateAgentDropdown">
                                                <div
                                                    className="jc-dropdown-item"
                                                    onClick={() => {
                                                        setbuildModal(true);
                                                        setpersonaModal(false);
                                                        setShow(false);
                                                        reset();
                                                    }}
                                                >
                                                    🧠 Build with AI
                                                </div>

                                                <div
                                                    className="jc-dropdown-item"
                                                    onClick={() => {
                                                        setpersonaModal(true);
                                                        setbuildModal(false);
                                                        setShow(false);
                                                        reset1();
                                                    }}
                                                >
                                                    ✏️ Start from scratch
                                                </div>

                                                <div
                                                    className="jc-dropdown-item"
                                                    onClick={() => {
                                                        setcusModal(true);
                                                        reset1();
                                                        setpersonaModal(false);
                                                        setbuildModal(false);
                                                        setShow(false);
                                                    }}
                                                >
                                                    🗄️ Select Template
                                                </div>
                                            </div>
                                        )} */}
                                    </div>
                                </div>
                               </div>
                                                    
                            </div>
                            {/* <h4 className="page-title">AI Agents</h4> */}
                            <h4 className="page-title">AI Agents</h4>
                            
                        </div>
                        {/* <div className="page-title-box">
                            <h4 className="page-title">  </h4>
                        </div> */}

                    </div>
                </div>
                <div className="row">
                    <div className="col-12">
                            <div className="">
                                <DataTable
                                    columns={columns }
                                    data={ListofAiAgents}
                                    progressPending={agentLoading}
                                progressComponent={
                                    <div
                                        className="d-flex justify-content-center align-items-center"
                                        style={{
                                            backgroundColor: "#000",
                                            width: "100%",
                                            minHeight: "120px",
                                        }}
                                    >
                                        <div
                                            className="spinner-border text-success"
                                            role="status"
                                        />
                                    </div>
                                }
                                    customStyles={customStyles}
                                    pagination
                                    paginationServer
                                    paginationTotalRows={totalCount}
                                    paginationDefaultPage={currentPage}
                                    paginationPerPage={perPage}
                                    onChangeRowsPerPage={handlePerPageChange}
                                    onChangePage={handlePageChange}
                                    paginationRowsPerPageOptions={[10, 20, 30, 50]}
                                    noDataComponent={<p className="text-muted bg-black">No AI Agents found.</p>}
                                    pointerOnHover
                                />
                            </div>
                        
                    </div>
                </div>
            </div>

           



            {/* <Modal show={hide} onHide={() => sethide(false)} aria-labelledby="contained-modal-title-vcenter" centered>
                <Modal.Header closeButton>
                    <Modal.Title> Choose Your Call Type</Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    <h3 className="mb-3 text-info">Choose Your Call Type</h3>
                    <div className="d-flex flex-column flex-sm-row justify-content-center gap-2">
                        <Link to={`/singlecall?agentid=${agentID}`} className="btn btn btn-success rounded-pill  w-100 w-sm-auto"><i className="ri-phone-line  fs-18"></i> Single Call</Link>
                        <Link to={`/bulkcall?agentid=${agentID}`} className="btn-outline-success rounded-pill  btn w-100 w-sm-auto"><i className="ri-phone-line fs-18"></i> Bulk Calls</Link>
                    </div>

                </Modal.Body>
            </Modal> */}

            {/* SUCCESS MODAL */}
            <Modal
                show={showSuccessModal}
                onHide={() => setShowSuccessModal(false)}
                centered
                backdrop="static"
                contentClassName="border-0 shadow-lg rounded-4"
            >
                <Modal.Body className="p-4 text-center">
                    <div
                        className="d-inline-flex align-items-center justify-content-center rounded-circle mb-3"
                        style={{
                            width: 80,
                            height: 80,
                            background: "linear-gradient(135deg, #28a745, #20c997)",
                        }}
                    >
                        <i className="bi bi-check-lg text-white" style={{ fontSize: "2.5rem" }} />
                    </div>
                    <h5 className="fw-bold mb-2">Success</h5>
                    <p className="text-muted mb-4">{successMessage}</p>
                    <button
                        className="btn btn-success px-4 fw-semibold rounded-pill"
                        onClick={() => setShowSuccessModal(false)}
                    >
                        Done
                    </button>
                </Modal.Body>
            </Modal>

            {/* ERROR MODAL */}
            <Modal
                show={showErrorModal}
                onHide={() => setShowErrorModal(false)}
                centered
                backdrop="static"
                contentClassName="border-0 shadow-lg rounded-4"
            >
                <Modal.Body className="p-4 text-center">
                    <div
                        className="d-inline-flex align-items-center justify-content-center rounded-circle mb-3"
                        style={{
                            width: 80,
                            height: 80,
                            background: "linear-gradient(135deg, #dc3545, #ff6b6b)",
                        }}
                    >
                        <i className="bi bi-x-lg text-white" style={{ fontSize: "2.2rem" }} />
                    </div>
                    <h5 className="fw-bold mb-2">Something went wrong</h5>
                    <p className="text-muted mb-4">{errorMessage}</p>
                    <button
                        className="btn btn-outline-danger px-4 fw-semibold rounded-pill"
                        onClick={() => setShowErrorModal(false)}
                    >
                        Close
                    </button>
                </Modal.Body>
            </Modal>



        </>
    )
}
